import { Directive } from "@angular/core"

@Directive({
    selector: "cui-layout-header, cui-layout-footer, cui-layout-sidebar"
})
export class CUILayoutTagsDirective {}
